export default {
	methods: {
		async login(remember = false, emiteClose = false) {
			try {
				let { data } = await this.form.post('/login')

				// Save the token.
				this.$store.dispatch('auth/saveToken', {
					token: data.token,
					remember: remember,
				})

				// Fetch the user.
				await this.$store.dispatch('auth/fetchUser')
			} catch ({ response }) {
				// this.$notify(response.data.message)
				this.$notifyAllErrors(response.data.errors)
				return
			}

			if (emiteClose) {
				this.$emit('close')
				return
			}

			//redirect
			this.$router.push({ name: 'profile' }).catch(() => null)
		},
	},
}
